import axios from 'axios';

const getEUMessage = () => {
  return new Promise((resolve) => {
    axios
      .get('https://vn.demo.synamedia.co.uk/messages/eu_message.txt')
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => resolve(''));
  });
};

export { getEUMessage };
